import { useRootStore } from '@nandosaus/state-management';
import { useEffect } from 'react';

const useLoadPastOrders = () => {
  const { MemberStore, PastOrdersStore } = useRootStore();

  useEffect(() => {
    if (MemberStore.isSignedIn) {
      PastOrdersStore.loadOrders();
    }
  }, [MemberStore.isSignedIn, PastOrdersStore]);
};

export { useLoadPastOrders };
